import { render, staticRenderFns } from "./MapModal2.vue?vue&type=template&id=98f74e40&scoped=true"
import script from "./MapModal2.vue?vue&type=script&lang=js"
export * from "./MapModal2.vue?vue&type=script&lang=js"
import style0 from "./MapModal2.vue?vue&type=style&index=0&id=98f74e40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f74e40",
  null
  
)

export default component.exports